<template>
  <div id="root">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col>
        <div class="grid-content bg-purple">
          <h1 style="margin: 0;">
            {{ title }}
          </h1>
        </div>
      </el-col>
    </el-row><el-row>
      <el-col>
        <h3 v-if="error">
          An error ocurred. Try reloading the page or confirming that you were added to Discipleship by a staff member.
        </h3>
        <div class="grid-content" style="margin-bottom: 10px;" v-if="!error">
          <el-button
            v-if="isOneOfTheseRoles(
              ['affiliate', 'chaplain', 'td', 'superadmin', 'parish-missionary', 'parish-td'])"
            type="primary"
            @click.native="modals.addDiscipleshipGroup = true"
          >
            Add Discipleship Group <i class="el-icon-plus el-icon--right" />
          </el-button>
          <el-button
            v-if="isOneOfTheseRoles(
              ['affiliate', 'chaplain', 'td', 'superadmin', 'parish-missionary', 'parish-td'])"
            type="danger"
            @click.native="modals.endGroup = true"
          >
            End a Group <i class="el-icon-minus el-icon--right" />
          </el-button>
          <el-button
            v-if="isOneOfTheseRoles(
              ['affiliate', 'chaplain', 'td', 'superadmin', 'parish-missionary', 'parish-td'])"
            class="transfer-button"
            @click.native="modals.editDiscipleshipGroup = true"
          >
            Edit a Discipleship Group <i class="el-icon-arrow-right el-icon--right" />
          </el-button>
          <br>
          <el-select
            class="select-default col-md-2"
            filterable
            v-if="isOneOfTheseRoles(['regional'])"
            clearable
            @change="updateTable"
            style="margin:10px;"
            v-model="locationId"
            placeholder="Select location..."
          >
            <el-option
              v-for="item in locationsDropdown"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-table
      v-loading="!isReady"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      :data="discipleshipGroups"
    >
      <el-table-column
        prop="leader"
        label="Leader"
        width="220"
      />
      <el-table-column
        prop="participants"
        label="Participants"
        width="400"
      />
      <el-table-column
        prop="parent_group_leader"
        label="Parent Group's Leader"
        width="300"
      />
    </el-table>
    <add-discipleship-group-modal
      :show="modals.addDiscipleshipGroup"
      @close="modals.addDiscipleshipGroup = false"
      @save="updateTable"
    />
    <edit-discipleship-group-modal
      :show="modals.editDiscipleshipGroup"
      @close="modals.editDiscipleshipGroup = false"
      @save="updateTable"
    />
    <end-group-modal
      :show="modals.endGroup"
      @close="modals.endGroup = false"
      @save="updateTable"
    />
  </div>
</template>

<script>

import AddDiscipleshipGroupModal from '../../components/DiscipleshipGroup/AddDiscipleshipGroupModal';
import EditDiscipleshipGroupModal from '../../components/DiscipleshipGroup/EditDiscipleshipGroupModal';
import EndGroupModal from '../../components/DiscipleshipGroup/EndGroupModal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DiscipleshipGroupsRepository = RepositoryFactory.get('discipleshipGroups');

export default {
    data() {
        return {
            title: 'Discipleship Groups Table',
            namespace: 'Discipleship',
            discipleshipGroups: [],
            error: '',
            isReady: false,
            locationsDropdown: [],
            locationId: '',
            modals: {
                addDiscipleshipGroup: false,
                editDiscipleshipGroup: false,
                endGroup: false,
                removeDisciple: false,
            }
        };
    },
    components: {
        AddDiscipleshipGroupModal,
        EditDiscipleshipGroupModal,
        EndGroupModal,
    },
    computed: {
    },
    methods: {
        updateTable() {
            this.isReady = false;
            DiscipleshipGroupsRepository.getDiscipleshipGroups(this.locationId)
                .then((response) => {
                    this.discipleshipGroups = response.data.data;
                    this.locationsDropdown = response.data.locations;
                    this.isReady = true;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        }
    },
    created() {
        this.updateTable();
    },
};
</script>
